import React, { Fragment } from 'react';
import Twitter from '../leap/dist/assets/img/icons/social/twitter.svg';
import Facebook from '../leap/dist/assets/img/icons/social/facebook.svg';
import LinkedIn from '../leap/dist/assets/img/icons/social/linkedin.svg';

const TWITTER_ACCOUNT = 'nospoilersai';

const getTwitterLink = ({ hashtag, url, description }) =>
  `https://twitter.com/intent/tweet?hashtags=${hashtag}&original_referer=${url}&ref_src=twsrc%5Etfw&text=${description}&url=${url}&via=${TWITTER_ACCOUNT}`;

export default function SharePage({ page, ...props }) {
  return null;
  return (
    <div {...props}>
      <hr />
      <div className="d-flex align-items-center">
        <span className="text-small mr-1">Share this article:</span>
        <div className="d-flex mx-2">
          <a href={getTwitterLink(page)} target="_blank" rel="noopener noreferrer" className="btn btn-round btn-primary mx-1">
            <Twitter className="icon icon-sm" alt="twitter social icon" />
          </a>
          <a href="#" className="btn btn-round btn-primary mx-1">
            <Facebook className="icon icon-sm" alt="facebook social icon" />
          </a>
          <a href="#" className="btn btn-round btn-primary mx-1">
            <LinkedIn className="icon icon-sm" alt="linkedin social icon" />
          </a>
        </div>
      </div>
    </div>
  );
}